/**
 * Canvas screens store boolean answers as "yes"/"no" strings: conditions and
 * radio groups authored in Screen Studio compare against those literals, so
 * every editor that writes a checkbox value has to use the same shape.
 */
export const BOOLEAN_FIELD_VALUES = {
  YES: "yes",
  NO: "no",
};

const CHECKED_VALUES = [BOOLEAN_FIELD_VALUES.YES, true, "true", "on"];

export const toBooleanFieldValue = (checked) =>
  checked ? BOOLEAN_FIELD_VALUES.YES : BOOLEAN_FIELD_VALUES.NO;

export const isBooleanFieldChecked = (value) =>
  CHECKED_VALUES.indexOf(value) >= 0;
